import React from 'react';

const  newEditIcon = ({ size = 18,color = '#0623c1', ...props }) => (
                          <svg width={size} height={size} viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path fill-rule="evenodd" clip-rule="evenodd" d="M2.6465 7.80949L7.8095 2.64649C8.0045 2.45149 8.321 2.45149 8.516 2.64649L9.354 3.48449C9.549 3.67949 9.549 3.99599 9.354 4.19099L4.1905 9.35349C4.097 9.44749 3.97 9.49999 3.8375 9.49999H2.5V8.16249C2.5 8.02999 2.5525 7.90299 2.6465 7.80949Z" stroke="#1D2433" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                              <path d="M6.875 3.58008L8.42 5.12508" stroke="#1D2433" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                          </svg>

);

export default newEditIcon;